import { IsOptional, IsInt } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';

/**
 * DTO para filtrar el Dashboard Liner.
 * Permite filtrar por cliente y temporada.
 *
 * Uso: Se utiliza en el endpoint GET /api/v1/dashboard/liner para filtrar datos del dashboard.
 */
export class DashboardLinerFilterDto {
  /**
   * ID del cliente a filtrar.
   * Si no se especifica, muestra todos los clientes.
   */
  @ApiPropertyOptional({
    description:
      'ID del cliente a filtrar (opcional, todos si no se especifica)',
    example: 66,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  clienteId?: number;

  /**
   * ID de la temporada a consultar.
   * Si no se especifica, usa la temporada activa actual.
   * @example 7 (2024-2025)
   */
  @ApiPropertyOptional({
    description:
      'ID de la temporada (opcional, usa temporada activa si no se especifica)',
    example: 7,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  temporadaId?: number;
}
